import { Model } from '@vuex-orm/core'

export default class Achievement extends Model {
    static entity = 'achievements'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            description: this.attr(''),
            completed: this.attr(false)
        }
    }
}